import { render } from "./MyIzins.vue?vue&type=template&id=00419ad8&scoped=true"
import script from "./MyIzins.vue?vue&type=script&lang=js"
export * from "./MyIzins.vue?vue&type=script&lang=js"

import "./MyIzins.vue?vue&type=style&index=0&id=00419ad8&scoped=true&lang=css"

import exportComponent from "/home/umut/Desktop/tm-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00419ad8"]])

export default __exports__